import {Link} from "react-router-dom"
import {getTimeFromNow} from "../../../functions/time"
import {RepoMeta} from "../../../interfaces/repos"
import {ProfileDB} from "../../../models/ProfileDB.model"
import styles from "./index.module.scss"

interface ProfileRepoListingProps {
  profile: ProfileDB
  repos: RepoMeta[]
}

export const ProfileRepoListing = (props: ProfileRepoListingProps) => {
  const pubKey = props.profile.address.path
  const profileOrbitId = props.profile.address.root

  return (
    <div className={styles.RepoContainer}>
      <div className={styles.RepoHeader}>
        My Repositories
      </div>
      <div className={styles.RepoList}>
        {
          props.repos.map(repo => {
            const address = repo.address.split("/").slice(2).join("/")
            const repoUrl = `/repos/${profileOrbitId}/${pubKey}/${address}/codes`
            return (
              <Link className={styles.RepoCard} key={repo.address} to={repoUrl}>
                <div className={styles.RepoName}>{repo.name}</div>
                <div className={styles.RepoDesc}>{repo.description}</div>
                <div className={styles.LastUpdate}>
                  Created {getTimeFromNow(repo.createAt, true)}
                </div>
              </Link>
            )
          })
        }
      </div>
    </div>
  )
}
